import { Model } from 'vue-models'
import TextField from './types/TextField'

export default class Port extends Model {
  static defaults () {
    return {
      name: 'port',
      basePath: 'ports',
      computed: {
        __str__ () { return this.locode }
      }
    }
  }
  static schema () {
    return {
      id: { type: Number },
      name: { type: TextField },
      locode: { type: TextField },
      latitude: { type: Number },
      longitude: { type: Number },
      timezone: { type: TextField },
      country: {
        type: Object,
        properties: {
          id: { type: Number },
          code: { type: String },
          name: { type: String }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/port.js